function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#4667ED",
  d: "M542.7,793.5c0,0.5,0.1,1,0.1,1.5c0,0,0,0,0,0C542.8,794.5,542.8,794,542.7,793.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#4667ED",
  d: "M463.2,123.1c-188.1,0-340.6,152.5-340.6,340.6c0,88.9,34,169.7,89.8,230.4c30.7-64.2,85.2-114.7,152.1-140.3 c30.8-11.7,64.2-18.2,99.1-18.2c110.6,0,206.1,64.5,251,158c55.5-60.6,89.4-141.3,89.4-230C803.8,275.7,651.3,123.1,463.2,123.1z  M463.5,520.7c-38.6,0-73.5-15.4-99.1-40.4c-26.4-25.8-42.8-61.8-42.8-101.6c0-39.8,16.4-75.8,42.8-101.6 c25.6-25,60.5-40.4,99.1-40.4c78.4,0,141.9,63.6,141.9,141.9C605.4,457.2,541.9,520.7,463.5,520.7z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M463.5,236.8c-38.6,0-73.5,15.4-99.1,40.4c-26.4,25.8-42.8,61.8-42.8,101.6c0,39.8,16.4,75.8,42.8,101.6 c25.6,25,60.5,40.4,99.1,40.4c78.4,0,141.9-63.5,141.9-141.9C605.4,300.4,541.9,236.8,463.5,236.8z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M463.5,535.8c-34.9,0-68.3,6.4-99.1,18.2c-66.9,25.5-121.4,76.1-152.1,140.3c62.3,67.8,151.6,110.3,250.9,110.3 c27.4,0,54.1-3.3,79.7-9.4c0-0.5-0.1-1-0.1-1.5c0,0.5,0.1,1,0.1,1.5C610,779,669.4,743,714.5,693.8 C669.6,600.3,574.1,535.8,463.5,535.8z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A8FC",
  d: "M542.9,795.3c0-0.1,0-0.2,0-0.2c0,0,0,0,0,0c0,0.4,0,0.8,0.1,1.2C542.9,795.9,542.9,795.6,542.9,795.3z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A8FC",
  d: "M463.2,0.2C207.1,0.2-0.4,207.7-0.4,463.8s207.6,463.6,463.6,463.6s463.6-207.6,463.6-463.6 S719.2,0.2,463.2,0.2z M714.5,693.8C669.4,743,610,779,542.9,795c0,0.1,0,0.2,0,0.2c0,0.3,0,0.7,0,1c0-0.4-0.1-0.8-0.1-1.2 c-25.6,6.1-52.2,9.4-79.7,9.4c-99.3,0-188.6-42.5-250.9-110.3c-55.7-60.6-89.8-141.5-89.8-230.4c0-188.1,152.5-340.6,340.6-340.6 s340.6,152.5,340.6,340.6C803.8,552.4,769.9,633.2,714.5,693.8z"
});

const SvgSignIn = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 927 927",
    style: {
      enableBackground: "new 0 0 927 927"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSignIn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sign-in.226c5a0b.svg";
export { ForwardRef as ReactComponent };